import React from "react"

const Floaters = () => (
  <div className="floating-area">
    <ul className="floating-circles">
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
    </ul>
  </div>
)

export default Floaters
